var productButton = {
    base: {
        px: 4,
        py: 5,
        maxWidth: "100%",
        display: "flex",
        backgroundColor: "white",
        cursor: "pointer",
        ":hover": {
            backgroundColor: "primary.5",
        },
        ":disabled, &[data-disabled='true']": {
            cursor: "not-allowed",
            boxShadow: "none",
            ":hover": {
                backgroundColor: "inherit",
            },
        },
    },
};

export { productButton };
//# sourceMappingURL=product-button.js.map
